import { Component, OnInit, Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { GlobalsService } from '../services/globals.service';
import { MenuItem, MenuType } from '../MenuItems';
import { FormGroup, FormControl } from '@angular/forms';
import { FormItem } from '../components/form/FormItem';
import { FieldTypes } from '../FieldTypes';
import { MenuService } from '../services/menu.service';
@Pipe({
	name: 'filter'
  })
  export class NavFilterPipe implements PipeTransform {
	constructor(
	  public translate2: TranslateService,
	  protected globals: GlobalsService
	) {
	  translate2.use(globals.langLocale.substr(0, 2));
	}
  
	transform(items: any[], searchText: string): any[] {
	  if (!items) return [];
	  if (!searchText || searchText.trim() === '') return items;
  
	  searchText = searchText.toLowerCase();
  
	  return items.filter(it => {
		let childFind = false;
  
		// Ana menü ismini çeviriyle güncelle
		it.name = this.translate2.instant(it.name) || it.name;
		if (it.name && it.name.toLowerCase().includes(searchText)) {
		  return true;
		}
  
		// Alt menüleri kontrol et
		if (it.children && it.children.length > 0) {
		  it.children.forEach(ic => {
			ic.name = this.translate2.instant(ic.name) || ic.name;
			if (ic.name && ic.name.toLowerCase().includes(searchText)) {
			  childFind = true;
			}
  
			if (ic.children && ic.children.length > 0) {
			  ic.children.forEach(icc => {
				icc.name = this.translate2.instant('pageNames.page_' + icc.pageId) || icc.name;
				if (icc.name && icc.name.toLowerCase().includes(searchText)) {
				  childFind = true;
				}
			  });
			}
		  });
		}
  
		return childFind;
	  });
	}
  }
  @Component({
	selector: 'vias-nav',
	templateUrl: './nav.component.html',
	styleUrls: ['./nav.component.scss']
  })
  export class NavComponent implements OnInit {
	mt = MenuType;
	form: FormGroup;
	item: FormItem;
	menuSearchText: string = ''; // Başlangıç değeri boş string olmalı
	menuItems: MenuItem[];
  
	constructor(
	  public translate: TranslateService,
	  protected globals: GlobalsService,
	  protected menu: MenuService
	) {
	  translate.use(globals.langLocale.substr(0, 2));
  
	  // FormGroup ve FormControl başlatma işlemi
	  this.form = new FormGroup({
		menuSearch: new FormControl('') // Başlangıç değeri boş string
	  });
  
	  this.item = {
		type: FieldTypes.Text,
		name: 'menuSearch',
	  };
  
	  this.translate.get('search').subscribe((translated: string) => {
		this.item.label = translated;
	  });
	}
  
	ngOnInit(): void {
	  this.menuItems = this.getAll();
  
	  // Form kontrolündeki değeri dinleyerek arama metnini güncelle
	  this.form.controls['menuSearch'].valueChanges.subscribe(value => {
		this.menuSearchText = value || ''; // Eğer `null` veya `undefined` gelirse boş string ata
	  });
	}
  
	getAll(): MenuItem[] {
	  const MenuItems = this.menu.getMenu();
	  const pages: number[] = [];
	  this.globals.pagePermissions.forEach(e => {
		const perm = this.handlePermissions(e.permission);
		for (let i = 0; i < perm.length; i++) {
		  if (perm.charAt(i) === '1') {
			pages.push(e.pageId + i);
		  }
		}
	  });
  
	  const menu = MenuItems.filter(
		function f(o) {
		  if (pages.includes(o.pageId)) { return true; }
		  if (o.children) { return (o.children = o.children.filter(f)).length; }
		}
	  );
  
	  return menu;
	}
  
	handlePermissions(perm: string): string {
	  let x: string = '';
	  if (perm.length > 0) {
		x = Number.parseInt(perm, 16).toString(2);
		while (x.length < 50) {
		  x = '0' + x;
		}
	  }
	  return x;
	}
	onChangeInput(event: any): void {
		this.menuSearchText = event;  // Gelen değeri doğrudan menuSearchText'e ata
	  }
  }
  
